<div class="order-status-modern-view">
  <strong>Status:</strong><span class="order-status" [ngClass]="config.class">{{ config.status  }}</span>
</div>